import { apiPost, apiUpload, API_ENDPOINTS } from "../utils/apiUtils";

/**
 * Events Service
 * Handles event management, categories, and file uploads
 */
const EventService = {
  // Event Operations
  /**
   * Get all events
   * @param {Object} filters - Filter parameters
   * @returns {Promise} API response
   */
  async getAllEvents(filters) {
    return apiPost(API_ENDPOINTS.EVENTS.GET_ALL, filters);
  },

  /**
   * Get event details
   * @param {Object} eventData - Event identifier
   * @returns {Promise} API response
   */
  async getEventsDetails(eventData) {
    return apiPost(API_ENDPOINTS.EVENTS.GET_DETAILS, eventData);
  },

  /**
   * Create new event
   * @param {Object} eventData - Event creation data
   * @returns {Promise} API response
   */
  async createEvent(eventData) {
    return apiPost(API_ENDPOINTS.EVENTS.CREATE, eventData);
  },

  /**
   * Update event
   * @param {Object} eventData - Event update data
   * @returns {Promise} API response
   */
  async updateEvent(eventData) {
    return apiPost(API_ENDPOINTS.EVENTS.UPDATE, eventData);
  },

  /**
   * Delete event
   * @param {Object} eventData - Event deletion data
   * @returns {Promise} API response
   */
  async deleteEvent(eventData) {
    return apiPost(API_ENDPOINTS.EVENTS.DELETE, eventData);
  },

  /**
   * Update event like count
   * @param {Object} likeData - Like count data
   * @returns {Promise} API response
   */
  async updateLikeCount(likeData) {
    return apiPost(API_ENDPOINTS.EVENTS.UPDATE_LIKE_COUNT, likeData);
  },

  // Category Operations
  /**
   * Get all categories
   * @param {Object} filters - Filter parameters
   * @returns {Promise} API response
   */
  async getAllCategory(filters) {
    return apiPost(API_ENDPOINTS.CATEGORIES.GET_ALL, filters);
  },

  /**
   * Create new category
   * @param {Object} categoryData - Category creation data
   * @returns {Promise} API response
   */
  async createCategory(categoryData) {
    return apiPost(API_ENDPOINTS.CATEGORIES.CREATE, categoryData);
  },

  /**
   * Update category
   * @param {Object} categoryData - Category update data
   * @returns {Promise} API response
   */
  async updateCategory(categoryData) {
    return apiPost(API_ENDPOINTS.CATEGORIES.UPDATE, categoryData);
  },

  /**
   * Delete category
   * @param {Object} categoryData - Category deletion data
   * @returns {Promise} API response
   */
  async deleteCategoryEvent(categoryData) {
    return apiPost(API_ENDPOINTS.CATEGORIES.DELETE, categoryData);
  },

  // File Operations
  /**
   * Upload file
   * @param {FormData} formData - File upload data
   * @returns {Promise} API response
   */
  async fileUpload(formData) {
    return apiUpload(API_ENDPOINTS.UPLOAD, formData);
  },

  // Legacy method for backward compatibility
  async updateEventsDetails(eventData) {
    return this.updateCategory(eventData);
  },

  // Feed Posts Operations
  /**
   * Get all feed posts with filters (post/reel)
   * @param {Object} filters - Filter parameters including post_type
   * @returns {Promise} API response
   */
  async getAllFeedPosts(filters) {
    return apiPost(API_ENDPOINTS.FEED_POSTS.GET_ALL, filters);
  },

  /**
   * Delete feed post
   * @param {Object} postData - Post deletion data with post_id
   * @returns {Promise} API response
   */
  async deleteFeedPost(postData) {
    return apiPost(API_ENDPOINTS.FEED_POSTS.DELETE, postData);
  },
};

export default EventService;
